"use client";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";

import Image from "@/components/AppImage";
import Link from "@/components/AppLink";
import Slider from "react-slick";
import banner_carousel_icon_1 from "/public/img/banner-carousel-icon-1.png";
import banner_carousel_icon_2 from "/public/img/banner-carousel-icon-2.png";
import banner_carousel_icon_3 from "/public/img/banner-carousel-icon-3.png";
import banner_carousel_icon_4 from "/public/img/banner-carousel-icon-4.png";
import banner_carousel_icon_5 from "/public/img/banner-carousel-icon-5.png";

const Banner = () => {
  const settings = {
    infinite: true,
    autoplay: true,
    focusOnSelect: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    dotsClass: "section-dots",

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  return (
    <section className="banner-section index-6">
      <div className="overlay">
        <div className="banner-content pb-120">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-10">
                <div className="main-content">
                  <h1>Send crypto payouts from one freelancer wallet</h1>
                  <p className="xxlr">
                    Push USDC, BTC, or ETH to vendors, collaborators, or your
                    cold storage—tracked, compliant, and reconciled next to fiat
                    activity.
                  </p>
                  <Link href={getDashboardPathUrl("/register-2")} className="cmn-btn">
                    Get Start Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="banner-bottom">
        <div className="container">
          <Slider {...settings} className="banner-carousel-index6">
            <div className="single">
              <div className="single-item text-center">
                <div className="icon">
                  <Image src={banner_carousel_icon_1} alt="icon" />
                </div>
                <div className="bottom">
                  <h5>Pay vendors on-chain</h5>
                  <p>
                    Settle invoices to wallet addresses you trust with memo
                    references your accountant will recognize.
                  </p>
                </div>
              </div>
            </div>
            <div className="single">
              <div className="single-item text-center">
                <div className="icon">
                  <Image src={banner_carousel_icon_2} alt="icon" />
                </div>
                <div className="bottom">
                  <h5>Split project payments</h5>
                  <p>
                    Distribute percentages to teammates anywhere without waiting
                    on slow wire cutoffs.
                  </p>
                </div>
              </div>
            </div>
            <div className="single">
              <div className="single-item text-center">
                <div className="icon">
                  <Image src={banner_carousel_icon_3} alt="icon" />
                </div>
                <div className="bottom">
                  <h5>Bulk crypto runs</h5>
                  <p>
                    Upload a CSV of wallet IDs and fire hundreds of transfers in
                    a single approval flow.
                  </p>
                </div>
              </div>
            </div>
            <div className="single">
              <div className="single-item text-center">
                <div className="icon">
                  <Image src={banner_carousel_icon_4} alt="icon" />
                </div>
                <div className="bottom">
                  <h5>Treasury moves</h5>
                  <p>
                    Sweep earnings between hot wallets, exchanges, or custody
                    partners when strategy changes.
                  </p>
                </div>
              </div>
            </div>
            <div className="single">
              <div className="single-item text-center">
                <div className="icon">
                  <Image src={banner_carousel_icon_5} alt="icon" />
                </div>
                <div className="bottom">
                  <h5>Off-ramp reminders</h5>
                  <p>
                    Convert a slice back to fiat for taxes or living expenses
                    without leaving OracleMarket.
                  </p>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Banner;
